import { pdfEmbed, shared } from "../src/taskpane/config/constants";
import dayjs from "dayjs";
import { IAuthAccount } from "../src/taskpane/interfaces/IAuthTokenResultDto";
import { logger } from "./logger";

export const detectIEOrEdge = (): boolean => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    const msie11 = ua.indexOf("Trident/");
    const msedge = ua.indexOf("Edge/");
    const isIE = msie > 0 || msie11 > 0;
    const isEdge = msedge > 0;
    return isIE || isEdge;
}

export const detectEdgeOrSafari = (): boolean => {
    const ua = window.navigator.userAgent;
    const isEdge = ua.indexOf("Edge/") > 0;
    if (isEdge) return true;
    const isSafari = ua.indexOf("Safari/") > 0 && !(ua.indexOf("Chrome/") > 0 || ua.indexOf("Chromium/") > 0);
    if (isSafari) return true;
    return false;
}

export const IEEdgeSmoothScroll = (element: Element, targetY: number, duration: number) => {
    let startingY = element.scrollHeight;
    const diff = targetY - startingY;

    if (!diff) return;

    // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294
    const easing = (t: number) => {
        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
    let start: number;

    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        // Elapsed miliseconds since start of scrolling.
        let time = timestamp - start;
        // Get percent of completion in range [0, 1].
        let percent = Math.min(time / duration, 1);
        // Apply the easing.
        // It can cause bad-looking slow frames in browser performance tool, so be careful.
        percent = easing(percent);
        element.scrollTop = startingY + diff * percent;

        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
            window.requestAnimationFrame(step);
        }
    })
}

let docubirdWindow: Window = null;
export const OpenInBrowser = (url: string, openInSelf: boolean = false): void => {
    try {
        if (typeof Office !== "undefined" && Office.context.requirements.isSetSupported("OpenBrowserWindowApi")) {
            Office.context.ui.openBrowserWindow(url);
            return;
        }
    } catch (error) {
        logger(error, "BrowserUtils: OpenInBrowser");
    }

    if (openInSelf) {
        window.open(url, "_self");
    }
    else if (docubirdWindow === null || docubirdWindow.closed) {
        docubirdWindow = window.open(url, "Docubird");
    } else {
        docubirdWindow = window.open(url, "Docubird");
        docubirdWindow?.focus();
    }
}

export const OpenPdfInBrowser = (account: IAuthAccount, driveId: string, itemId: string, isInOneDrive: boolean = false): void => {
    const isOfficeContextAvailable: boolean = typeof Office !== "undefined";
    const url: string = `${process.env.PDF_URL}?${shared.params.accountId}=${account?.accountId}&${shared.params.username}=${account?.username}&${shared.params.itemId}=${itemId}&${shared.params.driveId}=${driveId}&${pdfEmbed.params.isInOneDrive}=${isInOneDrive === true ? "1" : "0"}&${shared.params.language}=${isOfficeContextAvailable ? (Office.context?.displayLanguage ?? dayjs.locale() ?? navigator.language) : (dayjs.locale() ?? navigator.language)}`;
    try {
        if (isOfficeContextAvailable && Office.context.requirements.isSetSupported("OpenBrowserWindowApi")) {
            Office.context.ui.openBrowserWindow(url);
            return;
        }
    } catch (error) {
        logger(error, "BrowserUtils: OpenPdfInBrowser");
    }

    if (docubirdWindow === null || docubirdWindow.closed) {
        docubirdWindow = window.open(url, "Docubird");
    } else {
        docubirdWindow = window.open(url, "Docubird");
        docubirdWindow?.focus();
    }
}